import { render } from "./PurchaseModal.vue?vue&type=template&id=422b030e&scoped=true&ts=true"
import script from "./PurchaseModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseModal.vue?vue&type=script&lang=ts"

import "./PurchaseModal.vue?vue&type=style&index=0&id=422b030e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422b030e"]])

export default __exports__